<template>
  <div class="footer" v-if="!isRegister">
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="1" offset-md="1">
          <img class="footer-logo" src="@/assets/img/logo_etat_fribourg.svg" />
        </v-col>
        <v-col cols="12" md="7">
          <div class="footer-credentials">
            <p>
              {{ $t('footer.design_concept') }} |
              <a href="https://www.eikon.ch" target="_blank">eikonlab</a> -
              María Chacón, Baptiste Torche, Tobias Vannay
            </p>
            <p>{{ $t('footer.development') }} | Nicolas Buntschu</p>
            <p>
              {{ $t('footer.video_speech') }} |
              <a href="https://takeoffproductions.ch" target="_blank">
                Take off productions
              </a>
            </p>
            <p>{{ $t('footer.video_concert') }} | Bertrand Chanez</p>
          </div>
        </v-col>
        <v-col cols="12" md="2">
          <div class="footer-social">
            <a href="https://twitter.com/etat_fribourg" target="_blank">
              <v-icon color="#000" :size="50">mdi-twitter</v-icon>
            </a>
            <a href="https://www.facebook.com/sfp.bba" target="_blank">
              <v-icon color="#000" :size="50">mdi-facebook</v-icon>
            </a>
            <a
              href="https://www.instagram.com/remisetitres.fr.ch"
              target="_blank"
            >
              <v-icon color="#000" :size="50">mdi-instagram</v-icon>
            </a>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  computed: {
    isRegister() {
      return (
        this.$route.matched &&
        this.$route.matched[0] &&
        this.$route.matched[0].path === '/inscription'
      )
    }
  }
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.footer {
  padding: 52px 0 70px;
  border-top: solid 2px #000;
}

.footer-logo {
  width: 72px;
  margin: 5px 0 0 -24px;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    margin-left: 0;
  }
}

.footer-credentials {
  margin-left: 30px;

  p {
    font-size: 16px;
    line-height: 1.2;
    margin-bottom: 0 !important;
  }

  a {
    color: #000 !important;
  }

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    margin-left: 0;
  }
}

.footer-social {
  display: flex;
  justify-content: flex-end;
  margin-right: -24px;

  a {
    text-decoration: none;

    &:not(:first-child) {
      margin-left: 16px;
    }

    &:hover .v-icon {
      color: #5a7bff !important;
    }
  }

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    margin: 0;
    justify-content: flex-start;

    a {
      margin: 0 8px;
    }

    .v-icon {
      font-size: 40px !important;
    }
  }
}
</style>
